import React from "react";

import DesktopView from "./DesktopView/DesktopView";
import MobileViewOnly from "./MobileView/MobileView";
import { useMediaQuery } from "react-responsive";

function Section2() {
	const isDesktopOrLaptop = useMediaQuery({
		query: "(min-device-width: 1025px)",
	});
	const isTablet = useMediaQuery({ query: "(max-width: 1024px)" });
	const isMobileDevice = useMediaQuery({
		query: "(max-device-width: 414px)",
	});

	if (isDesktopOrLaptop) {
		return <DesktopView />;
	} else if (isTablet) {
		return <DesktopView />;
	} else if (isMobileDevice) {
		return <MobileViewOnly />;
	}
}

export default Section2;
